import { useQuery } from "@tanstack/react-query";
import { apiRequest, getUserSession } from "utils/api";
import { LoanModel } from "../../../providers/loans/loan.model";
import { useTenant } from "modules/tenant/providers/tenant-provider";

export const useLoansQuery = () => {
  const { user } = useTenant();

  const fetchLoans = async () => {
    const session = await getUserSession();

    if (!session) {
      return [];
    }

    const response = await apiRequest("/supabase/loans/select");
    return response.loans;
  };

  return useQuery<LoanModel[]>({
    queryKey: ["loans"],
    queryFn: fetchLoans,
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes in milliseconds
  });
};
